import { Snackbar, Box, Typography, Grow } from "@mui/material";
import { getToastConfig, setToastConfig } from "store/slice/UI";
import { useAppSelector, useAppDispatch } from "app/hooks";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

const Toast = () => {
    const dispatch = useAppDispatch();

    const { title, content, duration } = useAppSelector(getToastConfig);
    const shouldOpen = Boolean(title);

    const handleCloseSnackbar = () => {
        dispatch(setToastConfig({ title: "", content: "" }));
    };

    return (
        <Snackbar
            open={shouldOpen}
            TransitionComponent={Grow}
            autoHideDuration={duration}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <Box
                sx={{
                    width: 360,
                    padding: 2,
                    borderRadius: 1,
                    backgroundColor: "neutrals.dark",
                    border: "1px solid",
                    borderColor: "neutrals.main",
                }}
            >
                <Box display="flex" alignItems="center" mb={0.5}>
                    <CustomIcon icon={icons.circledCheck} sx={{ fontSize: 18, color: "common.white", mr: 0.8 }} />
                    <Typography sx={{ fontSize: 18, fontWeight: 600, color: "common.white" }}>{title}</Typography>
                </Box>
                <Typography sx={{ fontSize: 14, color: "common.white" }}>{content}</Typography>
            </Box>
        </Snackbar>
    );
};

export default Toast;
